import { render, staticRenderFns } from "./LeagueCard.vue?vue&type=template&id=6603d9be&scoped=true&"
import script from "./LeagueCard.vue?vue&type=script&lang=js&"
export * from "./LeagueCard.vue?vue&type=script&lang=js&"
import style0 from "./LeagueCard.vue?vue&type=style&index=0&id=6603d9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603d9be",
  null
  
)

export default component.exports